import type { NskResponse } from "~/models/Api";
import type { CompanyStoreSettingEdit } from "~/models/CompanyStoreSetting";
import { putRequest } from "~/utils/api/api_handler";

const paths = {
	update: "/company_store_setting"
} as const;

export const update = async (
	companyStoreSetting: CompanyStoreSettingEdit
): Promise<NskResponse> => putRequest(paths.update, { companyStoreSetting });
